import React from "react";
import { Col, Container, Row, Image } from "react-bootstrap";

export const SawariBenifits = () => {
  return (
    <Container>
      <div className="pb-2 pt-5 webkit">
        <h2 className="text-black text-4xl font-semibold">Sawari Benefits</h2>
      </div>
      <Row className="mt-4">
        <Col lg="3" xl="3" sm="6" xs="6" className="mt-4">
          <div
            className="border-black rounded-xl webkit box"
            style={{ background: "#1E1E1E" }}
          >
            <div>
              <Image
                className="w-2/6"
                src={require("../../assets/sawariBenifits.png")}
              />
              <h2 className="text-white text-xl font-semibold py-2">
                Fixed Price
              </h2>
              <p className="text-white font-semibold py-2">
                No surge pricing, no hidden costs. The price you see is the
                price you pay
              </p>
            </div>
          </div>
        </Col>
        <Col lg="3" xl="3" sm="6" xs="6" className="mt-4">
          <div
            className="border-black rounded-xl webkit box"
            style={{ background: "#1E1E1E" }}
          >
            <div>
              <Image
                className="w-2/6"
                src={require("../../assets/sawariBenifits.png")}
              />
              <h2 className="text-white text-xl font-semibold py-2">
                Fixed Price
              </h2>
              <p className="text-white font-semibold py-2">
                No surge pricing, no hidden costs. The price you see is the
                price you pay
              </p>
            </div>
          </div>
        </Col>
        <Col lg="3" xl="3" sm="6" xs="6" className="mt-4">
          <div
            className="border-black rounded-xl webkit box"
            style={{ background: "#1E1E1E" }}
          >
            <div>
              <Image
                className="w-2/6"
                src={require("../../assets/sawariBenifits.png")}
              />
              <h2 className="text-white text-xl font-semibold py-2">
                Fixed Price
              </h2>
              <p className="text-white font-semibold py-2">
                No surge pricing, no hidden costs. The price you see is the
                price you pay
              </p>
            </div>
          </div>
        </Col>
        <Col lg="3" xl="3" sm="6" xs="6" className="mt-4">
          <div
            className="border-black rounded-xl webkit box"
            style={{ background: "#1E1E1E" }}
          >
            <div>
              <Image
                className="w-2/6"
                src={require("../../assets/sawariBenifits.png")}
              />
              <h2 className="text-white text-xl font-semibold py-2">
                Fixed Price
              </h2>
              <p className="text-white font-semibold py-2">
                No surge pricing, no hidden costs. The price you see is the
                price you pay
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
